import { render, staticRenderFns } from "./CustomActionList.vue?vue&type=template&id=5dfe8b48&scoped=true&"
import script from "./CustomActionList.vue?vue&type=script&lang=js&"
export * from "./CustomActionList.vue?vue&type=script&lang=js&"
import style0 from "./CustomActionList.vue?vue&type=style&index=0&id=5dfe8b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe8b48",
  null
  
)

export default component.exports